module.exports = __webpack_public_path__ + "img/inu_main1.520055ec.jpg";